import PropTypes from 'prop-types';
import React from 'react';
import { FaChevronDown } from 'react-icons/fa';

import Collapse from '../../../ui/Atoms/Collapse';
import Dropdown from '../../../ui/Atoms/Dropdown';
import { linkFormater } from './linkFormater';

import * as S from './LanguageSelect.styles';

export const LanguageSelect = ({ alternateLanguages, lang, isMobile }) => {
  if (!lang) {
    return null;
  }

  const Container = isMobile ? Collapse : Dropdown;
  const displayedLang = lang.slice(0, 2).toUpperCase();
  const hasNoAltLang = !!(!alternateLanguages || alternateLanguages.length < 1);

  const currentLangButton = (open, isOpen) => (
    <S.SelectedItem isMobile={isMobile} isOpen={isOpen}>
      <S.SelectedItemAction
        hasNoAltLang={hasNoAltLang}
        isOpen={isOpen}
        onFocus={open}
      >
        {displayedLang}
        <FaChevronDown />
      </S.SelectedItemAction>
    </S.SelectedItem>
  );

  if (hasNoAltLang) {
    return currentLangButton();
  }

  return (
    <Container
      content={({ open, close }) => (
        <S.Item isMobile={isMobile}>
          {alternateLanguages
            .filter(language => language.lang !== lang)
            .map((language, index) => {
              const displayedLanguage = language.lang.slice(0, 2).toUpperCase();

              return (
                <S.ItemAction
                  isMobile={isMobile}
                  key={`${language}-${index}`}
                  onBlur={close}
                  onFocus={open}
                  href={linkFormater(language)}
                >
                  {displayedLanguage}
                </S.ItemAction>
              );
            })}
        </S.Item>
      )}
      main={({ open, isOpen }) => currentLangButton(open, isOpen)}
    />
  );
};

LanguageSelect.propTypes = {
  /**
   * Array of language data including url, type, lang and uid.
   */
  alternateLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      lang: PropTypes.string,
      type: PropTypes.string,
      uid: PropTypes.string,
    })
  ),
  /**
   * Displays the dropdown on desktop and collapse the menu on mobile.
   */
  isMobile: PropTypes.bool,
  /**
   * Current language (ISO language code).
   */
  lang: PropTypes.string.isRequired,
};

LanguageSelect.defaultsProps = {
  isMobile: false,
};
